import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SacStructure } from '../../model/sac-client.model';

@Component({
    selector: 'app-sac-header-tab',
    templateUrl: './header-tab.component.html',
    styleUrls: ['./header-tab.component.scss'],
    standalone: false
})
export class SacHeaderTabComponent {

  @Input() structure: SacStructure;

  @Input() selected: boolean;

  @Output()
  close = new EventEmitter<any>();

  @Output()
  select = new EventEmitter<any>();

  closeTabbed() {
    this.close.next(this.structure);
  }

  selectTabbed() {
    this.select.next(this.structure);
  }

}
